import React, { useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT } from '../../Utils/responsive';
import DonationHistoryFindWeb from './web';
import DonationHistoryFindMob from './mob';

const DonationHistoryFind = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile ? <DonationHistoryFindMob /> : <DonationHistoryFindWeb />;
};

export default DonationHistoryFind;

